import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router/';
import { User } from 'anchor-shared/lib/model/entity/user';

@Component({
  selector: 'app-customer-gov-id-badge',
  templateUrl: './customer-gov-id-badge.component.html',
  styleUrls: ['./customer-gov-id-badge.component.scss'],
})
export class CustomerGovIdBadgeComponent implements OnInit {
  @Input()
  user: User;

  @Input()
  userId: number;

  constructor(private router: Router) {}

  ngOnInit() {}

  navToUser(): void {
    if (this.userId) {
      this.router.navigate(['manage/admin/user/edit/' + this.userId]);
    }
  }
}
